<template>
    <div class="call-button-container">
        <div class="button-wrapper" @click.stop="handleButtonClick">
            <woot-button
                tooltip="Realizar ligação"
                color-scheme="primary"
                class-names="btn-call-outgoing"
                icon="telephone"
                :disabled="btnDisabled"
                @click="telephone"
            >Ligar</woot-button>
            
            <!-- Dropdown icon when button is disabled -->
            <div v-if="btnDisabled && hasTemplates" class="dropdown-icon" @click.stop="toggleDropdown">
                <i class="icon ion-chevron-down"></i>
            </div>
        </div>
        
        <!-- Dropdown menu -->
        <div v-if="showDropdown && btnDisabled" class="dropdown-menu" @click.stop>
            <div class="dropdown-item" @click="selectTemplate('call_voice')">
                Solicitar que o cliente ligue para a empresa
            </div>
            <div class="dropdown-item" @click="selectTemplate('call_permission')">
                Pedir permissão do cliente para contato telefônico
            </div>
        </div>
        
        <!-- Overlay to close dropdown -->
        <div v-if="showDropdown" class="dropdown-overlay" @click="closeDropdown"></div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CallLogAPI from 'dashboard/api/calllog';

export default {
  name: 'CallOutgoingButton',
  data() {
    return {
        permissions: null,
        btnDisabled: true,
        showDropdown: false,
    };
  },
  watch: {
    currentChat(newVal, oldValue) {
        if (newVal && newVal.primary_key && (!oldValue || oldValue.primary_key != newVal.primary_key)) {
            this.fetchCallPermissions();
        }
    }
  },
  computed: {
    ...mapGetters({
        currentChat: 'getSelectedChat',
        inboxAllowCalls: 'inboxes/allowCalls',
        getInbox: 'inboxes/getInbox'
    }),
    permissionActionStartCall() {
        return this.permissions?.actions?.find(p => p.action_name === 'start_call');
    },
    hasTemplates() {
        return this.inbox?.call_settings?.template_call_voice || this.inbox?.call_settings?.template_call_permission_request;
    },
    callVoiceTemplate() {
        if (!this.inbox?.call_settings?.template_call_voice || !this.inbox?.message_templates) {
            return null;
        }
        return this.inbox.message_templates.find(t => t.name === this.inbox.call_settings.template_call_voice);
    },
    callPermissionTemplate() {
        if (!this.inbox?.call_settings?.template_call_permission_request || !this.inbox?.message_templates) {
            return null;
        }
        return this.inbox.message_templates.find(t => t.name === this.inbox.call_settings.template_call_permission_request);
    },
    inbox() {
        return this.getInbox(this.currentChat.inbox_id);
    },
  },
  created() {
    if(this.currentChat){
        this.fetchCallPermissions();
    }
  },
  methods: {
    handleButtonClick(event) {
        if (this.btnDisabled && this.hasTemplates) {
            event.preventDefault();
            event.stopPropagation();
            this.toggleDropdown();
        }
    },
    toggleDropdown() {
        this.showDropdown = !this.showDropdown;
    },
    closeDropdown() {
        this.showDropdown = false;
    },
    selectTemplate(type) {
        let selectedTemplate = null;
        
        if (type === 'call_voice') {
            selectedTemplate = this.callVoiceTemplate;
        } else if (type === 'call_permission') {
            selectedTemplate = this.callPermissionTemplate;
        }
        
        if (selectedTemplate) {
            // Emitir evento para abrir o WhatsappTemplates com o template selecionado
            this.$emit('openWhatsappTemplate', selectedTemplate);
        }
        
        this.closeDropdown();
    },
    telephone() {
        this.btnDisabled = true;
        window.bus.$emit('open-call-outgoing-modal', {
            conversationId: this.currentChat.id,
            element: this.$el,
            cbOnHangup: this.fetchCallPermissions,
        });
    },
    checkBtnDisabled() {
        this.btnDisabled = !this.permissionActionStartCall?.can_perform_action;
    },
    async fetchCallPermissions() {
        if(this.inboxAllowCalls(this.currentChat.inbox_id) === false){
            this.btnDisabled = true;
            return;
        }
        try {
            const { data: responsePub } = await CallLogAPI.outgoing({
                call_action: 'permissions',
                conversation_id: this.currentChat.primary_key
            });
            this.permissions = responsePub;
            this.checkBtnDisabled();
        } catch (error) {
            console.error("Error fetching call permissions:", error);
            this.btnDisabled = true;
        }
    },
    
  }
};
</script>

<style scoped lang="scss">
.call-button-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: relative;
}

.button-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  
  .btn-call-outgoing {
    min-width: 150px;
    display: flex;
    justify-content: center;
  }
  
  .dropdown-icon {
    margin-left: 4px;
    padding: 4px;
    cursor: pointer;
    color: var(--color-woot);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: background-color 0.2s ease;
    
    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }
    
    i {
      font-size: 16px;
    }
  }
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  min-width: 370px;
  left: -200px;
  right: 0;
  background: white;
  border: 1px solid var(--color-border);
  border-radius: var(--border-radius-normal);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  overflow: hidden;
  margin-top: 4px;
  
  .dropdown-item {
    padding: 12px 16px;
    cursor: pointer;
    border-bottom: 1px solid var(--color-border-light);
    transition: background-color 0.2s ease;
    font-size: var(--font-size-small);
    
    &:last-child {
      border-bottom: none;
    }
    
    &:hover {
      background-color: var(--color-background);
    }
  }
}

.dropdown-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: transparent;
}
</style>